module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Contact information","firstname":"forename","lastname":"surname","phone":"Send a message"},"fi":{"pageTitle":"Yhteystiedot","firstname":"etunimi","lastname":"sukunimi","phone":"Lähetä viesti"}}')
  delete Component.options._Ctor
}
